// extracted by css-extract-rspack-plugin
export default {"item":"Xvio5","itemBullet":"raFy9"};